// import store from '@/store/store'
// import { BRANCHES_FETCH } from '@/store/action.types'
// store.dispatch(BRANCHES_FETCH)

const sidebarItems = [
  {
    url: '/profile',
    name_i18n: 'pages.profile',
    icon: 'PeopleCircleOneIcon'
  },
  {
    url: '/change_branch',
    name_i18n: 'pages.myCompany',
    icon: 'BuildingHomeIcon'
  },
  {
    url: '/employee_qr',
    name_i18n: 'pages.qrCode',
    icon: 'JewelCrownIcon'
  },
  {
    url: '/tips',
    name_i18n: 'pages.myTips',
    icon: 'MoneyCurrencyRubleCircleIcon'
  }
]
export default sidebarItems
